import { useState } from 'react';
import './App.css';
import './components/ResponsiveMobile.css'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Home from './screens/Home';
import About from './screens/About';
import Loader from './screens/Loader';
import Experience from './screens/Experience';
import Work from './screens/Work';
import Contact from './screens/Contact';
import Footer from './screens/Footer';


function App() {
  const [loader, setLoader] = useState(true)

 
    setTimeout(() => {
      setLoader(false)
    },2000)
    

  if(loader){
    return <Loader />
  }
  return (
    <div className="App">
       <Home />
       <About />
       <Experience />
       <Work />
       <Contact />
       <Footer />
    </div>
  );
}

export default App;
